module.exports = __webpack_public_path__ + "img/touxiang.cb536c5f.png";